export const environment = {

  production: true,
  //url : 'http://localhost:55000/api/',
  //url: 'http://67.207.84.99:6200/api/'
  // url: 'http://67.207.84.99:8200/api/'
  // url: 'http://67.207.84.99:5500/api/'
  url: 'https://test-api.vooyapp.com/api/',
  //url: "http://localhost:6005/api/",
  appointment:"https://test-partner-appointment.vooyapp.com/api/v1/",
  health_url: "https://test-health.vooyapp.com/api/v1/",
  master_url: "https://test-master.vooyapp.com/api/v1/",
  accounting_url: "https://test-accounting.vooyapp.com/api/v1/",
  support_url: "https://test-support.vooyapp.com/api/v1/",
  document_url: "https://test-file.vooyapp.com/api/v1/",
  notification_url: "https://test-notification.vooyapp.com/api/v1/",
  //notification_url: "http://localhost:6010/api/v1/",
  token_url: "https://test-token.vooyapp.com/",
  otp_url: "https://test-otp.vooyapp.com/api/v1/",
  food_master_url: "https://test-master.vooyfood.com/api/v1/",
  order_url: "https://test-order.vooyfood.com/api/v1/",
  seller_url: "https://test-seller.vooyfood.com/api/v1/",
  payment_url: "https://test-payment.vooyapp.com/api/v1/",
  firebaseConfig: {
    apiKey: "AIzaSyDqM5UnSZRUPyJWqEpG4MDNw4HHGA-rOgQ",
    authDomain: "vooy-admin-1593668544493.firebaseapp.com",
    projectId: "vooy-admin-1593668544493",
    storageBucket: "vooy-admin-1593668544493.appspot.com",
    messagingSenderId: "87603046231",
    appId: "1:87603046231:web:dea05a71b8e98373a00012",
    measurementId: "G-H1EHVMKY3H",
  },
  web_socket_url: "wss://test-api.vooyapp.com/ws",
  vooy_farma_url: "https://development.cms.vooyfarma.com",
};
